// extracted by mini-css-extract-plugin
export default {"heading-holder":"MainHeading_heading-holder__AGrbg","divider":"MainHeading_divider__E71et","centered":"MainHeading_centered__-Thzf"};